import React from "react";
const icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="m12 1.57-.54.516-6 6 1.08 1.078 4.71-4.71v15.093l-4.71-4.711-1.08 1.078 6 6 .54.516.54-.516 6-6-1.08-1.078-4.71 4.71V4.454l4.71 4.711 1.08-1.078-6-6L12 1.57Z" />
  </svg>
);

export default icon;
